export default {
  async getSettings(domain, serviceId) {
    const request = await fetch(`${domain}/api/v1/settings`, {
      method: 'GET',
      headers: {
        "Authorization": `Basic ${btoa(`api:${window.apiPwd}`)}`,
      },
    });
    return request.json()
  },
};